export { ProductCategories } from './ProductCategories'
export type {
  ProductCategoriesProps,
  ProductCategoryItemProps,
} from './ProductCategories'
